const ApplicationController = require('client/controllers/application-controller')

const $doc = $(document)

const ROLLOUT_FORM_SELECTOR = '.rollout-modifier__form'
const ROLLOUT_INPUT_SELECTOR = '.rollout-modifier__input'
const ROLLOUT_INPUT_MIN_SELECTOR = '.rollout-modifier__input--min'
const ROLLOUT_INPUT_MAX_SELECTOR = '.rollout-modifier__input--max'
const ROLLOUT_SUBMIT_SELECTOR = '.rollout-modifier__submit'

module.exports = class AdminController extends ApplicationController {
  rollout() {
    $doc.on('input', ROLLOUT_INPUT_SELECTOR, event => {
      const $target = $(event.currentTarget)
      const $form = $target.closest(ROLLOUT_FORM_SELECTOR)
      const $submit = $form.find(ROLLOUT_SUBMIT_SELECTOR)
      const $minInput = $form.find(ROLLOUT_INPUT_MIN_SELECTOR)
      const $maxInput = $form.find(ROLLOUT_INPUT_MAX_SELECTOR)
      $form.removeClass('has-success')
      $submit.prop('disabled', !isValidPercentageRange($minInput, $maxInput))
    })
    $doc.on('submit', ROLLOUT_FORM_SELECTOR, event => {
      event.preventDefault()
      const $form = $(event.currentTarget)
      const $submit = $form.find(ROLLOUT_SUBMIT_SELECTOR)
      const $minInput = $form.find(ROLLOUT_INPUT_MIN_SELECTOR)
      const $maxInput = $form.find(ROLLOUT_INPUT_MAX_SELECTOR)
      if (isValidPercentageRange($minInput, $maxInput)) {
        const handlerName = $form.attr('data-handler')
        const modifierName = $form.attr('data-modifier')
        const minValue = $minInput.val()
        const maxValue = $maxInput.val()
        const url = '/api/admin/rollouts/' + handlerName
        const data = {
          [modifierName]: { min: minValue, max: maxValue }
        }
        this.ajax({ url, method: 'put', data })
        .then(function () {
          $form.addClass('has-success')
          $minInput.prop('defaultValue', minValue)
          $maxInput.prop('defaultValue', maxValue)
          $submit.attr('disabled', true)
        })
        .catch(() => window.alert('Error updating rollout'))
      }
    })
  }
}

function clampPercentage(value) {
  return Math.min(Math.max(parseFloat(value), 0), 100)
}

function isValidPercentageRange($minInput, $maxInput) {
  const minValue = clampPercentage($minInput.val())
  const maxValue = clampPercentage($maxInput.val())
  const minDefault = clampPercentage($minInput.prop('defaultValue'))
  const maxDefault = clampPercentage($maxInput.prop('defaultValue'))
  return (
    (minValue != minDefault || maxValue != maxDefault) &&
    (maxValue > minValue || (minValue == 0 && maxValue == 0))
  )
}
